import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { ExpandableInput } from '@eika/expandable-input';
import { InputLabel } from '@eika/input';

import { useTranslation } from '../../translations';
import { TilbakemeldingFormData } from './kvittering';

const TilbakemeldingKommentar: FC = () => {
    const { kvittering } = useTranslation();
    const { register } = useFormContext<TilbakemeldingFormData>();

    return (
        <div>
            <InputLabel label={kvittering.labelTilbakemelding} sublabel={kvittering.subLabelTilbakemelding} />
            <ExpandableInput {...register('kommentar')} />
        </div>
    );
};

export default TilbakemeldingKommentar;
